import type { InstallerReport } from '@mcgames/contracts';
import { Badge, Button } from '@mcgames/ui';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './InstallerReports.module.css';

export type InstallerReportsProps = {
  reports: InstallerReport[];
  /** The step's path in the editor. */
  currentPath: string;
  onUse: (installerPath: string) => void;
};

/** Installers users picked because a `run_installer` step's file was missing. */
export function InstallerReports({ reports, currentPath, onUse }: InstallerReportsProps) {
  const { t } = useTranslation('admin');
  const ids = useId();
  const titleId = `${ids}-title`;
  return (
    <section className={styles['reports']} aria-labelledby={titleId}>
      <h4 id={titleId} className={styles['title']}>
        {t('games.install.installerReports.title')}
      </h4>
      <ul className={styles['list']}>
        {reports.map((report, index) => {
          const pathId = `${ids}-${index}`;
          return (
            <li key={report.installerPath} className={styles['item']}>
              <span id={pathId} className={styles['path']}>
                {report.installerPath}
              </span>
              <span className={styles['count']}>
                {t('games.install.installerReports.count', { count: report.count })}
              </span>
              {report.installerPath === currentPath ? (
                <Badge tone="accent">{t('games.install.installerReports.inUse')}</Badge>
              ) : (
                <Button
                  size="sm"
                  variant="secondary"
                  aria-describedby={pathId}
                  onClick={() => onUse(report.installerPath)}
                >
                  {t('games.install.installerReports.use')}
                </Button>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
